import React, { useState, useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import {
  Box,
  Card,
  CardContent,
  Divider,
  FormControlLabel,
  Grid,
  IconButton,
  Switch,
  ToggleButton,
  ToggleButtonGroup,
  Typography,
  useTheme,
} from "@mui/material";
import { AddCircle, ArrowBackIosNew, RemoveCircle } from "@mui/icons-material";
import { AppSingleton, difficulties } from "../services/user_config";
import { getAdaptivFontSize, getRoute } from "../utils/CommonUtils";

const LayoutConfigComponent = () => {
  const appSingleton = new AppSingleton();

  return (
    <Card sx={{ minWidth: 275, p: window.screen.width < 768 ? 1 : 2 }}>
      <CardContent>
        <Typography
          noWrap
          sx={{
            fontSize: getAdaptivFontSize(window.screen.width < 768 ? getAdaptivFontSize(18) : getAdaptivFontSize(36)),
          }}
        >
          UI布局
        </Typography>
        <Divider />
        <Grid container spacing={1} sx={{ display: "flex", alignItems: "center", pt: 4 }}>
          <Grid item xs={6}>
            <Typography
              noWrap
              sx={{ fontSize: getAdaptivFontSize(window.screen.width < 768 ? getAdaptivFontSize(16) : getAdaptivFontSize(32)) }}
            >
              亮色 / 暗黑模式
            </Typography>
          </Grid>
          <Grid item xs={1} />
          <Grid item xs={5} sx={{ display: "flex", justifyContent: "center" }}>
            <FormControlLabel
              control={
                <Switch
                  disabled
                  defaultChecked={appSingleton.isDarkMode}
                  value={appSingleton.isDarkMode}
                  onChange={(evt) =>
                    appSingleton.setIsDarkModel((prevIsDarMode) => {
                      console.log(evt);
                      return !!evt.target.checked;
                    })
                  }
                  sx={{
                    transform: `scale(${Math.floor(appSingleton.fontScale * 1.5)})`,
                  }}
                />
              }
              label={
                <Typography
                  noWrap
                  sx={{
                    ml: 2 * appSingleton.fontScale,
                    fontSize: getAdaptivFontSize(window.screen.width < 768 ? getAdaptivFontSize(16) : getAdaptivFontSize(32)),
                  }}
                >
                  {appSingleton.isDarkMode ? "暗黑" : "亮色"}
                </Typography>
              }
            />
          </Grid>
        </Grid>
        <Grid container spacing={1} sx={{ pt: 4, display: "flex", alignItems: "center" }}>
          <Grid item xs={6}>
            <Typography
              noWrap
              sx={{ fontSize: getAdaptivFontSize(window.screen.width < 768 ? getAdaptivFontSize(16) : getAdaptivFontSize(32)) }}
            >
              字體大小
            </Typography>
          </Grid>
          <Grid item xs={1} />
          <Grid item xs={5}>
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "cetner",
              }}
            >
              <IconButton onClick={() => appSingleton.setFontScale(appSingleton.fontScale - 0.1)}>
                <RemoveCircle
                  sx={{
                    fontSize: `${getAdaptivFontSize(
                      window.screen.width < 768 ? getAdaptivFontSize(16) : getAdaptivFontSize(32)
                    )}px`,
                  }}
                />
              </IconButton>
              <Typography
                noWrap
                sx={{
                  fontSize: getAdaptivFontSize(window.screen.width < 768 ? getAdaptivFontSize(16) : getAdaptivFontSize(32)),
                }}
              >
                {Math.floor(appSingleton.fontScale * 100)}%
              </Typography>
              <IconButton onClick={() => appSingleton.setFontScale(appSingleton.fontScale + 0.1)}>
                <AddCircle
                  sx={{
                    fontSize: `${getAdaptivFontSize(
                      window.screen.width < 768 ? getAdaptivFontSize(16) : getAdaptivFontSize(32)
                    )}px`,
                  }}
                />
              </IconButton>
            </Box>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
};

const MirrorConfigComponent = () => {
  const appSingleton = new AppSingleton();

  return (
    <Card sx={{ minWidth: 275, p: window.screen.width < 768 ? 1 : 2 }}>
      <CardContent>
        <Typography
          noWrap
          sx={{
            fontSize: getAdaptivFontSize(window.screen.width < 768 ? getAdaptivFontSize(18) : getAdaptivFontSize(36)),
          }}
        >
          智能鏡子
        </Typography>
        <Divider />
        <Grid container spacing={1} sx={{ pt: 4, display: "flex", alignItems: "center" }}>
          <Grid item xs={6}>
            <Typography
              noWrap
              sx={{
                fontSize: getAdaptivFontSize(window.screen.width < 768 ? getAdaptivFontSize(16) : getAdaptivFontSize(32)),
              }}
            >
              計分難度
            </Typography>
          </Grid>
          <Grid item xs={1} />
          <Grid
            item
            xs={5}
            sx={{
              display: "flex",
              justifyContent: "center",
            }}
          >
            <ToggleButtonGroup
              color="primary"
              value={appSingleton.mirrorDifficulty}
              exclusive
              onChange={(evt) => {}}
              aria-label="Platform"
            >
              {difficulties.map((_difficulty, index) => (
                <ToggleButton key={`ToggleButton-${index}`} value={`${_difficulty}`}>
                  <Typography sx={{ fontSize: getAdaptivFontSize(24) }}>{_difficulty} </Typography>
                </ToggleButton>
              ))}
            </ToggleButtonGroup>
          </Grid>
        </Grid>
        <Grid container spacing={1} sx={{ pt: 4, display: "flex", alignItems: "center" }}>
          <Grid item xs={6}>
            <Typography
              noWrap
              sx={{
                fontSize: getAdaptivFontSize(window.screen.width < 768 ? getAdaptivFontSize(16) : getAdaptivFontSize(32)),
              }}
            >
              動作偵測FPS
            </Typography>
          </Grid>
          <Grid item xs={1} />
          <Grid item xs={5}>
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <IconButton onClick={() => appSingleton.setMirrorFPS((prevFPS) => prevFPS - 1)}>
                <RemoveCircle sx={{ fontSize: `${getAdaptivFontSize(24)}px` }} />
              </IconButton>
              <Typography
                noWrap
                sx={{
                  fontSize: getAdaptivFontSize(window.screen.width < 768 ? getAdaptivFontSize(16) : getAdaptivFontSize(32)),
                }}
              >
                {appSingleton.mirrorFPS}
              </Typography>

              <IconButton onClick={() => appSingleton.setMirrorFPS((prevFPS) => prevFPS + 1)}>
                <AddCircle sx={{ fontSize: `${getAdaptivFontSize(24)}px` }} />
              </IconButton>
            </Box>
          </Grid>
        </Grid>
        <Grid container spacing={1} sx={{ pt: 4, display: "flex", alignItems: "center" }}>
          <Grid item xs={6}>
            <Typography
              noWrap
              sx={{ fontSize: getAdaptivFontSize(window.screen.width < 768 ? getAdaptivFontSize(16) : getAdaptivFontSize(32)) }}
            >
              背景效果
            </Typography>
          </Grid>
          <Grid item xs={1} />
          <Grid
            item
            xs={5}
            sx={{
              display: "flex",
              justifyContent: "center",
            }}
          >
            <FormControlLabel
              control={
                <Switch
                  defaultChecked={appSingleton.isEffect}
                  value={appSingleton.isEffect}
                  onChange={(evt) => appSingleton.setIsEffect((prevIsDarMode) => evt.target.checked)}
                  sx={{
                    transform: `scale(${Math.floor(appSingleton.fontScale * 1.5)})`,
                  }}
                />
              }
              label={
                <Typography
                  noWrap
                  sx={{
                    ml: 2 * appSingleton.fontScale,
                    fontSize: getAdaptivFontSize(window.screen.width < 768 ? getAdaptivFontSize(16) : getAdaptivFontSize(32)),
                  }}
                >
                  {appSingleton.isEffect ? "開啟" : "關閉"}
                </Typography>
              }
            />
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
};

const SettingPage = () => {
  const navigate = useNavigate();
  const theme = useTheme();

  return (
    <Box sx={{ p: window.screen.width < 768 ? 1 : 4 }}>
      <Grid
        container
        spacing={1}
        sx={{
          display: "flex",
          alignItems: "center",
        }}
      >
        <Grid item xs={1}>
          <IconButton
            onClick={() => {
              navigate(`${getRoute("landing-page")}`);
            }}
          >
            <ArrowBackIosNew />
          </IconButton>
        </Grid>
        <Grid item xs={11}>
          <Typography
            noWrap
            sx={{
              fontSize: getAdaptivFontSize(window.screen.width < 768 ? getAdaptivFontSize(30) : getAdaptivFontSize(60)),
              color: theme.palette.text.primary,
            }}
            calc
          >
            設定
          </Typography>
        </Grid>
      </Grid>

      <Box sx={{ p: window.screen.width < 768 ? 1 : 2 }}>
        <LayoutConfigComponent />
      </Box>
      <Box sx={{ p: window.screen.width < 768 ? 1 : 2 }}>
        <MirrorConfigComponent />
      </Box>
    </Box>
  );
};

const f = () => {};

export { SettingPage, f };
